import React from 'react';
import { trend } from '../../utils/trend';
import './TrendLabel.css';

interface TrendLabelProps {
  cur: number;
  prev: number;
  activeDays: number;
}

const LABEL: Record<ReturnType<typeof trend>, string> = {
  new: 'new',
  none: 'none',
  'low volume': 'low volume',
  active: '▲ active',
  declining: '▼ declining',
  steady: 'steady',
};

const TrendLabel: React.FC<TrendLabelProps> = ({ cur, prev, activeDays }) => {
  const t = trend(cur, prev);
  return (
    <span className={`trend-label trend-label-${t.replace(' ', '-')}`}>
      {LABEL[t]} · {activeDays}/7 days
    </span>
  );
};

export default TrendLabel;
